import { render, staticRenderFns } from "./BowSocials.vue?vue&type=template&id=fdfe6dfe&"
import script from "./BowSocials.vue?vue&type=script&lang=js&"
export * from "./BowSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports